<template>
	<div class="timer-event-table-wrap portal-compact-list-shell">
		<div>
			<v-data-table
				id="timer-events-table"
				:headers="headers"
				sort-by="dateTime"
				:sort-desc="true"
				:must-sort="true"
				:items="fixedUpEvents"
				:disable-pagination="true"
				:hide-default-footer="true"
				class="timer-events-table portal-compact-table"
				:mobile-breakpoint="200"
			>
				<template v-slot:item.invoiced="{ item }">
					<portal-status-pill
						v-if="item.invoiceId"
						background="var(--v-success_10-base)"
						color="var(--v-success-base)"
						@click.native.stop="openInvoice(item.invoiceId)"
					>
						Billed
					</portal-status-pill>
					<span v-else class="portal-cell-muted">—</span>
				</template>

				<template v-slot:item.timerStart="{ item }">
					<div class="portal-cell-truncate" :title="item.dateDisplay">
						{{ item.dateDisplay }}
					</div>
				</template>

				<template v-slot:item.timeWorkedSortable="{ item }">
					<div class='time-worked text-end' style="text-wrap: none">
						{{ item.timeWorked }}
					</div>
				</template>

				<template v-slot:item.projectName="{ item }">
					<div class="portal-cell-truncate" :title="item.projectName">
						{{ item.projectName | empty }}
					</div>
				</template>

				<template v-slot:item.deliverableOrTicket="{ item }">
					<div class="portal-cell-truncate portal-cell-primary" :title="item.deliverableOrTicket">
						{{ item.deliverableOrTicket | empty }}
					</div>
				</template>

				<template v-slot:item.notes="{ item }">
					<div class="portal-cell-truncate portal-cell-muted" :title="item.notes">
						{{ item.notes | empty }}
					</div>
				</template>

				<template v-slot:no-data>
					{{ $t('timetrack.time-entries.no-timetrack') }}
				</template>

				<template slot="body.append">
					<tr>
						<td class="portal-list-priority-compact"></td>
						<th class="total text-end"><span class="font-14">{{ this.$t('timetrack.time-entries.total') }}</span></th>
						<td><div class="time-worked text-end">{{timeWorkedTotal}}</div></td>
						<td v-if="!hideProject" class="portal-list-priority-medium"></td>
						<td></td>
						<td class="portal-list-priority-low"></td>
					</tr>
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
	import { DateTime } from 'luxon';
  import InvoiceDetails from '@/modules/invoices/InvoiceDetails';

	export default {
		name: 'TimerEventTable',
		components: {},
		props: {
			timerEvents: { type: Array, required: true },
			filter: { type: String, required: false, default: null },
			hideProject: { type: Boolean, required: false, default: false },
		},

		data() {
			return {
				DateTime: DateTime,
			};
		},

		mounted() {},

		methods: {
      openInvoice: function(invoiceId) {
        if(!invoiceId){
          return;
        }

        let binding = {
          invoiceId: invoiceId,
        };
        this.$store.state.globalModalController
            .openModal(InvoiceDetails, binding, true, false, 'document-lightbox')
            .then(() => this.getInvoices());
      },
		},

		filters: {
			empty: function(value) {
				if (!value) return '--';
				return value;
			},
		},

		computed: {
			fixedUpEvents: function() {
        let result = JSON.parse(JSON.stringify(this.timerEvents));

				result.forEach((item) => {
					let timerStart = DateTime.fromISO(item.timerStart);
          let timerEnd = timerStart.plus({seconds: item.duration});
					item.dateDisplay = timerStart.toFormat('DD');
					item.duration = timerEnd.diff(timerStart, ['hours', 'minutes', 'seconds', 'milliseconds']);
					item.timeWorkedSortable = timerEnd.diff(timerStart,['seconds']).seconds;
					item.timeWorked = item.duration.toFormat('h:mm:ss'); // Table display
          item.invoiced = !!item.invoiceId;
          item.deliverableOrTicket = (item.deliverableName ? item.deliverableName : '') + (item.ticketName ? item.ticketName : '');
				});

				if (!this.filter) {
					return result;
				}

				let search = this.filter.toLowerCase();

				return result.filter((item) => {
					if (item.projectName && item.projectName.toLowerCase().includes(search)) {
						return true;
          }else if (item.deliverableName && item.deliverableName.toLowerCase().includes(search)) {
            return true;
          }else if (item.ticketName && item.ticketName.toLowerCase().includes(search)) {
            return true;
					}else if (item.notes && item.notes.toLowerCase().includes(search)) {
						return true;
					} else {
						return false;
					}
				});
			},

			timeWorkedTotal: function() {
				let seconds = this.fixedUpEvents.reduce((a, b) => a + (b.timeWorkedSortable || 0), 0);
				let starty = DateTime.fromSeconds(0);
				let endy = DateTime.fromSeconds(seconds);
				let duration = endy.diff(starty, ['hours','minutes','seconds']);
				return duration.toFormat('h:mm:ss');
			},

			headers: function() {
				const headers = [
					{
						text: this.$t('timetrack.time-entries.status'),
						value: 'invoiced',
						width: 102,
						class: 'portal-list-priority-compact',
						cellClass: 'portal-list-priority-compact',
					},
					{ text: this.$t('global.date'), value: 'timerStart', width: 128 },
					{ text: this.$t('timetrack.time-entries.time-worked'), value: 'timeWorkedSortable', width: 112 },
					{
						text: this.$t('timetrack.time-entries.deliverable'),
						value: 'deliverableOrTicket',
						class: 'portal-list-grow',
						cellClass: 'portal-list-grow',
					},
					{
						text: this.$t('timetrack.time-entries.notes'),
						value: 'notes',
						class: 'portal-list-priority-low',
						cellClass: 'portal-list-priority-low',
					},
				];
				if (!this.hideProject) {
					headers.splice(3, 0, {
						text: this.$t('timetrack.time-entries.project'),
						value: 'projectName',
						width: 190,
						class: 'portal-list-priority-medium',
						cellClass: 'portal-list-priority-medium',
					});
				}
				return headers;
			},
		},

		watch: {},
	};
</script>

<style lang="scss">
	#timer-events-table {
		.time-worked {
			max-width: 140px;
			//color: var(--v-gray_80-base);
		}
		.total {
			color: var(--portal-text, var(--v-gray_80-base));
		}
	}

	.timer-event-table-wrap {
		padding: 16px;
	}

	.timer-events-table {
		cursor: default;
	}

	.timer-events-table tbody tr:last-child {
		background: var(--brand-surface, var(--v-gray_20-base));
	}

	.timer-events-table tbody tr:last-child th,
	.timer-events-table tbody tr:last-child td {
		background: var(--brand-surface, transparent);
		border-top: 1px solid var(--portal-border);
		color: var(--portal-text);
		font-weight: 650;
	}

	@media (max-width: 599px) {
		.timer-event-table-wrap {
			padding: 12px;
		}
	}
</style>
